import { render, staticRenderFns } from "./VerifyList.vue?vue&type=template&id=66488a74&"
import script from "./VerifyList.vue?vue&type=script&lang=js&"
export * from "./VerifyList.vue?vue&type=script&lang=js&"
import style0 from "./VerifyList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports